import React from "react";

export function Textarea({ className = "", ...props }) {
  // Default glass-style textarea with pure glassmorphism (no opacity changes)
  const defaultClasses = className.includes('bg-') 
    ? '' // If custom background is provided, don't add default
    : 'bg-white/90';
  
  const defaultTextColor = className.includes('text-')
    ? '' // If custom text color is provided, don't add default
    : 'text-[#4B5563]';
  
  const defaultPlaceholder = className.includes('placeholder:')
    ? '' // If custom placeholder is provided, don't add default
    : 'placeholder:text-[#94A3B8]';
  
  const defaultBorder = className.includes('border')
    ? '' // If custom border is provided, don't add default
    : 'border';

  return (
    <textarea
      {...props}
      className={`px-4 py-3 rounded-xl backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-white/50 transition-all shadow-sm w-full text-base leading-relaxed ${defaultClasses} ${defaultTextColor} ${defaultPlaceholder} ${defaultBorder} ${className}`}
      style={{ 
        fontSize: 'max(16px, 1rem)', 
        lineHeight: '1.6',
        borderColor: className.includes('border') && !className.includes('border-white') ? undefined : 'rgba(96, 165, 250, 0.3)',
        borderWidth: '1px',
        color: '#4B5563'
      }}
    />
  );
}
